// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueTk from 'vue-tk'
import config from 'config'
import 'assets/scss/main.scss'
require('echarts/lib/component/tooltip')
Vue.config.productionTip = false
function initVue () {
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
}
let plusReady = function () {
  return new Promise(function (resolve) {
    if (!VueTk.tkUa.isPlus) resolve()
    if (window.plus) {
      resolve()
    } else {
      document.addEventListener('plusready', function () {
        resolve()
      }, false)
    }
  })
}
async function init () {
  for (let i of config.initPlugins) {
    let p
    if (typeof i === 'object') {
      if (i.env !== config.env) continue
      p = require('./init/' + i.name)
    } else {
      p = require('./init/' + i)
    }
    if (p && p.default && p.default instanceof Promise) {
      await p.default
    }
    if (p && p.default && typeof p.default === 'function') {
      await p.default()
    }
  }
  await plusReady()
  initVue()
}
init()



// WEBPACK FOOTER //
// ./src/main.js